module.exports = __webpack_public_path__ + "img/badge_gray_pop-entrance.ef379a14.svg";